"use client";

import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { HeaderSection } from "../components/profile-page/HeaderSection/HeaderSection.tsx";
import { AboutSection } from "../components/profile-page/AboutSection/AboutSection.tsx";
import { CertificatesSection } from "../components/profile-page/CertificatesSection/CertificatesSection.tsx";
import { SubjectsSection } from "../components/profile-page/SubjectsSection/SubjectsSection.tsx";
import { LanguagesSection } from "../components/profile-page/LanguagesSection/LanguagesSection.tsx";

import { ScrollArea } from "@/components/ui/scroll-area.tsx";
import PATHS from "@/routes/paths.ts";
import { useProfileDataStore } from "@/features/profile/tutor/store/useProfileDataStore";
import { EducationSection } from "@/features/profile/tutor/components/profile-page/EducationSection/EducationSection.tsx";
import SettingsCard from "@/features/profile/tutor/components/profile-page/settings/SettingsCard.tsx";
import YoutubePreview from "@/features/profile/tutor/components/profile-page/AboutSection/YoutubePreview.tsx";
import ProfileEditDialog from "@/features/profile/tutor/components/profile-page/ProfileEditDialog/ProfileEditDialog";

export default function TutorProfilePage() {
  const { profileData: data } = useProfileDataStore();
  const redirect = useNavigate();

  useEffect(() => {
    if (data === undefined) {
      redirect(PATHS.TUTOR.CREATE_PROFILE);
    }
  }, []);
  const { t } = useTranslation("profile");

  if (!data) return <title>{`${t("profilePage")} - Ximly`}</title>;

  return (
    <ScrollArea className="h-[calc(100dvh_-_4rem)]">
      <title>{`${t("profilePage")} - Ximly`}</title>
      <div className="bg-background flex min-h-dvh flex-col-reverse items-center justify-center gap-4 space-y-6 px-1 sm:px-8 xl:flex-row xl:items-start">
        <div className="w-full space-y-6 lg:w-[50rem]">
          <HeaderSection />
          <div className="container mx-auto max-w-4xl">
            <div className="w-full space-y-4">
              <AboutSection />
              <EducationSection />
              <CertificatesSection />
              <SubjectsSection />
              <LanguagesSection />
            </div>
          </div>
        </div>
        <div className={"flex w-full flex-col gap-4 sm:min-w-[23rem] lg:w-[50rem] xl:w-fit"}>
          <SettingsCard />{" "}
          <YoutubePreview initialVideoUrl={data?.about_section.youtube_url} profileId={data?.id} />
        </div>
        <ProfileEditDialog />
      </div>
    </ScrollArea>
  );
}
